const secretKey = "holisto_secret_key";
const CryptoJS = require("crypto-js");

export const EncryptValue = (value) =>
  value ? CryptoJS.AES.encrypt(value, secretKey).toString() : "";

// Memoize AES decryption by ciphertext. crypto-js AES is very CPU- and
// allocation-heavy
const decryptCache = new Map();
const DECRYPT_CACHE_LIMIT = 200;

export const DecryptValue = (value) => {
  if (!value) return "";
  const cached = decryptCache.get(value);
  if (cached !== undefined) return cached;
  const plain = CryptoJS.AES.decrypt(value, secretKey).toString(
    CryptoJS.enc.Utf8
  );
  if (decryptCache.size >= DECRYPT_CACHE_LIMIT) {
    decryptCache.delete(decryptCache.keys().next().value);
  }
  decryptCache.set(value, plain);
  return plain;
};

export const setSessionStorage = (key, value) => {
  localStorage.setItem(key, EncryptValue(JSON.stringify(value)));
};

export const getSessionStorage = (key) => {
  try {
    const data = DecryptValue(localStorage.getItem(key));
    if (data && data.trim().length > 0) {
      return JSON.parse(data);
    }
    return null;
  } catch (e) {
    console.error(`Error parsing session storage for key "${key}":`, e);
    return null;
  }
};

export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, EncryptValue(value));
};

export const getLocalStorage = (key) => {
  const data = DecryptValue(localStorage.getItem(key));
  if (data) {
    return data;
  }
  return data;
};

export const fileToBase64 = (file) => {
  return new Promise((resolve) => {
    var reader = new FileReader();
    reader.onload = function (event) {
      resolve(event.target.result);
    };

    reader.readAsDataURL(file);
  });
};

export const buildQueryString = (params) =>
  Object.entries(params)
    .filter(([_, value]) => value !== null && value !== undefined && value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

export const formatDateFromDateString= (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};
// The single outlet a GM/RM is working in: the top-bar selection, falling back to the first outlet
// they manage. Returns { id, name } or null. Several screens re-derived this inline — use this.
export const getSelectedOutlet = () => {
  try {
    const rawSel = getSessionStorage("outletDetails");
    const sel = typeof rawSel === "string" ? JSON.parse(rawSel || "null") : rawSel;
    const selId = Number(sel?.id);
    if (selId > 0) return { id: selId, name: sel?.name || sel?.outletName || "" };
    const raw = getSessionStorage("managingOutlets");
    const list = typeof raw === "string" ? JSON.parse(raw || "null") : raw;
    const first = (list || [])
      .map((o) => ({ id: Number(o?.id ?? o?.outletId), name: o?.outletName || o?.name || "" }))
      .find((o) => o.id > 0);
    return first || null;
  } catch (e) {
    return null;
  }
};
